<template lang="pug">
section#home
  section.banner-area.relative
    .overlay.overlay-bg
    .container
      .row.fullscreen.align-items-center.justify-content-between
        .col-lg-6.col-md-7.col-sm-8
          .banner-content
            h1(v-html="$t('home.title')")
            p(v-html="$t('home.subtitle')")
            router-link.primary-btn(to="/start")
              | {{ $t('controls.start') }}
              span.lnr.lnr-arrow-right
        .col-lg-5.col-md-5.col-sm-4
          img.img-fluid(src='static/img/illustration2.png')

  section.section-gap.studio-area
    .overlay.overlay-bg
    .container
      .row.align-items-center
        .col-md-4.col-sm-6.text-center
          .studio-thumb
            img.img-fluid(src='static/img/s.jpg', alt='')
        .col-md-8.col-sm-6
          .studio-content
            h2 {{ $t('home.about.title') }}
            p(v-html="$t('home.about.text')")
            router-link.genric-btn.link(to="/start")
              | {{ $t('controls.start') }}
              span.lnr.lnr-arrow-right

  section.section-gap.achivement-area
    .container
      .row
        .col-lg-8.offset-lg-2.col-md-10.offset-md-1
          .row
            .col-lg-7.col-md-7.col-sm-8
              h3(v-html="$t('home.news.title')")
              p(v-html="$t('home.news.text')")
              #mc_embed_signup
                form.subscription.relative(v-on:submit.prevent="registerMail")
                  input(type='email', name='EMAIL', v-bind:placeholder='$t("home.news.mail")', required)
                  button.primary-btn(v-on:submit.prevent="registerMail")
                    | {{ $t('controls.subscribe') }}
                    span.lnr.lnr-arrow-right
            .col-lg-4.offset-lg-1.col-md-5.col-sm-4.text-right
              img.img-fluid(src='static/img/news.png')
</template>

<script>

import Swal from 'sweetalert2';

export default {
  name: 'Home',
  methods: {
    registerMail() {
      Swal(
        this.$t('home.mail.subscribed.title'),
        this.$t('home.mail.subscribed.text'),
        'success',
      );
    },
  },
  mounted() {
  },
};
</script>

<style lang="stylus" scoped>
@import '../../assets/css/variables.styl'

.fullscreen
  height 95vh
  min-height 500px
  max-height 1600px

.studio-area
  background url(/static/img/hypnotize.png) repeat
  .overlay-bg
    background rgba(color-main, .8)

.studio-thumb
  img
    filter grayscale(100%) contrast(1.25)

.achivement-area
  padding 50px

#mc_embed_signup
  margin-top 50px

@media (max-width: size-sm)
  .achivement-area
    padding-bottom 100px

@media (max-width: size-xs)
  .achivement-area
    img
      display none
      visibility hidden
</style>



// WEBPACK FOOTER //
// src/components/pages/Home.vue